import { render, staticRenderFns } from "./subacc_history_limit.vue?vue&type=template&id=0f3c3ba8&"
import script from "./subacc_history_limit.vue?vue&type=script&lang=js&"
export * from "./subacc_history_limit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports